<template>
<div>
    <el-card>
        <h1 style="margin-bottom: -8px; margin-top: -8px"> {{ isEdit ? $t('translationsUpdate') : $t('translationsCreate') }} </h1>
        <hr>
        <br>
        <form>
            <!-- <label class="block"> Name </label> -->
            <!-- <p v-if="isEdit"> {{translation.name}} </p> -->
            <InputField
                    :label="$t('translationsName')"
                    v-model="translation.name"/>

            <lang-tabs 
                typeField="textarea"
                :inputKey="'value'" 
                :inputValue="translation.value" 
                @langData="updateLangData" 
                :langErrors="{value: errors}"/>
            
            <span> App </span>
            <br>
                <el-radio v-model="translation.app_name" label="frontend">Frontend</el-radio>
                <el-radio v-model="translation.app_name" label="cms">Cms</el-radio>
        </form>
    </el-card>
    <shared-buttons discardPath="Translations" :isEdit="isEdit" @confirm-event-fired="save"/>
</div>
</template>

<script>
import LangTabs from '../LangTabs/LangTabs'
import InputField from '../Inputs/InputField'

export default {
    components: {
        LangTabs,
        InputField
    },
    props: {
        translation: {
            type: Object
        },
        isEdit: {
            type: Boolean
        }
    },
    data () {
        return {
            errors: ''
        }
    },
    created () {
        
    },
    methods: {
        async save () {
            let res, url

            this.isEdit ? url = 'updateTranslations' : url = 'addTranslation'
                        
            await this.$store.dispatch(url, this.translation)
            .then((response) => {
                res = response
            })            
            
            if (res === 'success') {
                this.$router.push({name: 'Translations'})
            } else if (res) {
                console.log(res);
                
                this.errors = res['value.en'][0]                          
            }
    },
        updateLangData (data) {  
        }
    }
    
}
</script>

<style>
.el-input {
    margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Translations/TranslationEdit.vue